import styled from "styled-components";

export const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledAspectRatioWrapper = styled.div`
  width: 100%;
  height: 0;
  overflow: hidden;
  padding-top: 100%;
  background: white;
  position: relative;
`;

export const StyledAspectRatio = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const StyledNote = styled.span`
  display: block;
  text-align: center;
  font-size: 12px;
  margin-top: 10px;
`;
